// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__cbzlS","description":"styles_description__G+1fG"};